<div class="attachments-board-view-container">
  <app-attachment-card
    *ngFor="let document of documents"
    class="attachment-card"
    (onAttachmentDownload)="attachmentDownload($event)"
    (onaAttachmentDelete)="attachmentDelete($event)"
    (onAttachmentLinkClicked)="attachmentLinkClicked($event)"
    [attachment]="document"
    [accountId]="accountId"
    [uploadViewModel]="uploadViewModel"
    [allDocuments]="documents"
    [contextualInfo]="getDocumentContextualInfo(document)"
  ></app-attachment-card>
</div>
